
import { defineComponent, inject, ref, computed, reactive } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";

//services
import PayrollService from "@/core/services/PayrollService"
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    props:{
        idinstitution: {
            type: null,
            required: false,
            default: null
        }
    },
    setup(props, {emit}) {
        const { t } = useI18n();
        const store = useStore();
        const isModalVisible = ref(false)
        const data = ref(<any> {});

        const loader = ref(false)
        const maxlength = ref(0)
        const minlength = ref(3)
        const searchFormRef = ref < FormInstance > ()
        const inputRef = ref<HTMLInputElement | null>(null);
        const pattern = ref<any>(/^[0-9]+$/)
        const searchForm = reactive(<any> {
            doctype: null,
            docnumber: null,
            idinstitution: null
        })
        const selectedDocument = ref<any>(null);
        const rules = reactive < FormRules > ({})

        const openModal = () => {
            isModalVisible.value = true
        }

        const getDocuments: any = computed < any > (() => {
            return store.getters.currentUser.type_documents;
        })

        const findDocumentById = (id: number) => {
            const document = getDocuments.value.find((doc: any) => doc.id === id);
            if (document) {
                selectedDocument.value = { ...document }; // Clona el objeto encontrado
            } else {
                selectedDocument.value = null; // Si no se encuentra, lo seteamos a null
            }
        };

        const changeDocType = () => {
            searchForm.docnumber = "";
            findDocumentById(searchForm.doctype);
            maxlength.value = selectedDocument.value.params
            minlength.value = 3
            if (searchForm.doctype == "1") {
                //maxlength.value = minlength.value = 15
                //maxlength.value = minlength.value = selectedDocument.value.params
                //pattern.value = /^[0-9]+$/
            } else {
                //maxlength.value = 13
                pattern.value = /^[a-zA-Z0-9]+$/
            }
            inputRef.value?.focus()
        }

        const onOpen = () => {
            searchForm.doctype = "1";
            findDocumentById(searchForm.doctype);
            maxlength.value = selectedDocument.value.params
            searchForm.idinstitution = props.idinstitution
        }

        const onOpened = () => {
            if(inputRef.value) inputRef.value.focus()
        }

        const onClosed = () => {
            resetForm(searchFormRef.value)
            data.value = {}
            loader.value = false
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) 
                    onSearch();
            });
        };

        const onSearch = async () => {
            loader.value = true
            data.value = {}
            searchForm.idinstitution = props.idinstitution
            await PayrollService.options('search', searchForm)
            .then( (res) => {
                loader.value = false
                data.value = res.data
                if (!res.data.status) {
                    isModalVisible.value = false
                }
                emit("onResponse", res.data)
            }).catch(({response}) => {
                loader.value = false
                errManager(response)
            })
        }

        const viewInfo = async () => {
            data.value.status = false
            emit("onResponse", data.value)
        }

        return{
            t,
            isModalVisible,
            data,
            loader,
            rules,
            maxlength,
            minlength,
            searchFormRef,
            inputRef,
            pattern,
            searchForm,
            getDocuments,

            //methods
            openModal,
            onOpen,
            onOpened,
            onClosed,
            resetForm,
            submitForm,
            changeDocType,
            onSearch,
            viewInfo
        }
    },
})
